import { toastAlert } from "$lib/commons-web2/toast-alert"
import { InvalidSessionError } from "@tastyworks/tastyworks-api"
import session from "$lib/tastyworks-rest/session.ts"
import { setPromptBeforeUnload } from "$lib/controller/prompt-before-unload.ts"
import { getGenericAlert } from "@tastyworks/error-handling"

export class AbortSubmissionError extends Error {
  constructor() {
    super("Uncaught AbortSubmissionError thrown outside Form context")
  }
}

function toast() {
  const { title, message } = getGenericAlert()
  toastAlert("error", title, message)
}

function redirectToSignup() {
  setPromptBeforeUnload(false)
  session.clear()
  window.location.assign("/signup")
}

// Handles errors within SvelteKit's load functions and initial rendering
export function handleLoadError({ error }: { error: unknown }) {
  console.error(error)

  if (error instanceof InvalidSessionError) {
    redirectToSignup()
    return
  }

  // No toast as they will see an error page
}

// Handles all other synchronous and async errors
export function handleError(error: unknown) {
  if (error instanceof InvalidSessionError) {
    redirectToSignup()
    return
  }

  toast()
}
